module.exports = __webpack_public_path__ + "static/img/conversation_1.d1598e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/conversation_1.png
// module id = 4457
// module chunks = 1